import { Button } from 'antd';
import React, { useState } from 'react';
import { useFetcher, useLoaderData } from 'react-router-dom';
import FileManager from '../../../components/inputs/fiel-manager';
import DocumentsDownloader from '../../template/documentDownloader';
import styles from './artwork-recieved.module.scss';

const ArtWorkReceived = () => {
    const { artworkData, productionDetails } = useLoaderData()
    const [isModalOpen, setModalOpen] = useState(false)
    const fetcher = useFetcher()
    return (<div className={styles.container}>
        <h3>Task for you</h3>
        <div className={styles.outerBox}>
            <div className={styles.artworkBox}>
                <p>Leopriting has uploaded the artwork. Please create a printable final proof and upload it.</p>
                {!!artworkData.comments && (
                    <><strong>Comment</strong>: {artworkData.comments}</>
                )}
                {artworkData.document && artworkData.document.map(({ url, name, comment }) => <DocumentsDownloader key={url} image={url} name={name} comment={comment} project_id={productionDetails.project_id} item_id={productionDetails.id} />)}
            </div>
            <Button type='primary' ghost={true} onClick={() => { setModalOpen(true) }}>Upload Final Proof</Button>
        </div>
        <br />
        <FileManager
            isOpen={isModalOpen}
            title="Send Proof to Leoprinting"
            project_id={productionDetails?.project_id}
            item_id={productionDetails?.id}
            onUpload={(imageData) => {
                fetcher.submit({
                    imageData: imageData,
                    id: productionDetails.id,
                    action: 'sendProof'
                }, {
                    method: 'post',
                    encType: 'application/json'
                })
            }}
            actionButtonText='Upload & Send'
            onClose={() => setModalOpen(false)}
            width={'60%'}
        />
    </div>
    )

}

export default ArtWorkReceived;